import React, { useEffect, useState } from 'react';

import { searchGuests } from '~/../components/shared/utils/api';
import { camelizeKeys } from 'humps';
import BeatLoader from 'react-spinners/BeatLoader';

const ViewAllGuests = ({ eventSlug, setModalSubtitle }) => {
  const [search, setSearch] = useState('');
  const [guests, setGuests] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    searchGuests(eventSlug, search).then(resp => {
      setGuests(camelizeKeys(resp.data));
      setIsLoading(false);
    });
  }, []);

  const handleTextSearch = (e) => {
    e.preventDefault();
    setSearch(e.target.value);
  };

  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      setIsLoading(true);
      searchGuests(eventSlug, search).then(resp => {
        setGuests(camelizeKeys(resp.data));
        setModalSubtitle(`${resp.data.length} Guests`);
        setIsLoading(false);
      });
    }
  };

  const messageLink = (e, id) => {
    e.preventDefault();
    window.location.href = `/conversations/new?participant_id=${id}`;
  };

  const renderGuest = (guest) => {
    return (
      <div className='card-container' key={guest.id}>
        <div className='voray-entity-card card-circle'>
          <div className='image'>
            <img src={guest.headshot} alt={guest.displayName} />
          </div>
          <div className='fw'>
            <div className='left'>
              <a href={`${location.origin}/users/${guest.slug}`}>
                <span className='text-black t3 w3'>{guest.displayName}</span>
              </a>
              <span className='block'>{guest.companyTitle}</span>
            </div>
            <button
              onClick={e => messageLink(e, guest.id)}
              className='btn-main right mt-15'
            >
              Message
            </button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div>
      <input
        className='form-control p-3 rounded-3 w-100'
        type='search'
        placeholder={'Search Guests'}
        aria-label='Search'
        onChange={e => handleTextSearch(e)}
        onKeyDown={handleKeyEnter}
        value={search}
      />
      {isLoading
        ? <BeatLoader color='#3d898b' speedMultiplier={0.5} className='mt-50 ml-15' />
        : <div className='view-all-entities'>{guests?.map(guest => renderGuest(guest))}</div>
      }
    </div>
  );
};

export default ViewAllGuests;
